import { CameraType } from "APP_ROOT/data/media";
export default {
  name: "tired_detection",
  localization: {
    en: {
      title: "Fatigue detected",
      settingsHeader: "Fatigue Detection",
    },
    fr: {
      title: "Fatigue détectée",
      settingsHeader: "Détection de Fatigue",
    }
  },
  proto: {
    name: "EVENT_RAVEN_TIRED_DETECTED",
    value: 141
  },
  isBuiltByDefault: true,
  isBuiltEnvironmentOverride: {
    showcase: false,
  },
  visibility:{
    reports: true,
    coaching: true,
    coachingNoFacialRecognition: true,
    warning: true,
  },
  isConsumerFeature: false,
  defaultCameraType: CameraType.CAMERA_CABIN,
  showBetaDecoration: false,
}
